export class Constants {
  static WorkshopClassifications: { 'text': string, 'value': string }[] = [
    {text: 'ورشة', value: 'workshop'},
    {text: 'مصنع', value: 'factory'}
  ];
  static WorkshopTypes: { 'text': string, 'value': string }[] = [
    {text: 'ليس لدي ورشة او مصنع', value: 'none'},
    {text: 'بي في سي', value: 'pvc'},
    {text: 'الوميتال', value: 'aluminium'},
    {text: 'بي في سي و الوميتال', value: 'both'},
    {text: 'غير ذلك', value: 'other'}
  ]

  static Text(list:any[], key: string): string {
    return list.find(x => x.value === key.toLowerCase())?.text;
  }
}
